export type SiteConfig = {
  siteUrl: string;
  siteName: string;
  defaultTitle: string;
  defaultDescription: string;
};

const DEFAULT_SITE_URL = 'https://fire-calc.com';

function normalizeSiteUrl(rawUrl: string): string {
  return rawUrl.endsWith('/') ? rawUrl.slice(0, -1) : rawUrl;
}

export const siteConfig: SiteConfig = {
  siteUrl: normalizeSiteUrl(import.meta.env.VITE_SITE_URL ?? DEFAULT_SITE_URL),
  siteName: 'Fire-Calc',
  defaultTitle: 'Fire-Calc Financial Calculators',
  defaultDescription: 'Financial calculators for FIRE planning, retirement modeling, debt payoff, housing decisions, and budgeting.'
};

export function toAbsoluteUrl(pathname: string): string {
  const normalizedPath =
    pathname === '/' ? '/' : `${pathname.replace(/\/+$/, '')}/`;
  return new URL(normalizedPath, `${siteConfig.siteUrl}/`).toString();
}

export function toAbsoluteResourceUrl(pathname: string): string {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return new URL(normalizedPath, `${siteConfig.siteUrl}/`).toString();
}
